<template>
  <Skeleton
      width="320px"
      height="100%"
      v-if="appState.initial"
  ></Skeleton>
  <ToggleButton v-else v-model="inputState.webSearch" :onLabel="onLabel" offLabel="WEB-поиск" onIcon="pi pi-globe"
                class="chat-widget__toggle-button--web-search"
                @change="patchDialog"
                offIcon="pi pi-circle" aria-label="Do you confirm" />
</template>
<script setup>
import ToggleButton from "primevue/togglebutton";
import {computed, ref} from "vue";
import Skeleton from "primevue/skeleton";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import {useInputStore} from "@/modules/chat/stores/userInputStore";

const appState = useAppStateStore();
const chatState = useChatStore();
const inputState = useInputStore();

const onLabel = computed(() => 'WEB-поиск (2.8 ₽ за запрос)');

const patchDialog = async () => {
  if (chatState.dialog === null) return;

  await chatState.patchDialog(chatState.dialog.id, {web_search: inputState.webSearch});
}
</script>